// // TODO: Create a BE Issue to handle `interactionType`

const tvOverlayBreak = {
  1: {
    // group: 'BasicOverlays',
    group: 'FourthWall',
    module: 'TempTwoSmallProducts',
  },
  2: {
    group: 'SimplePolls',
    module: 'TempEmojiPoll',
  },
  3: {
    group: 'SimplePolls',
    module: 'TempPIPPoll',
  },
  4: {
    group: 'TransparentOverlays',
    module: 'TempRightThirdScan',
  },
  5: {
    group: 'HeroPolls',
    module: 'TempLowerHeroPoll',
  },
  6: {
    group: 'SamsungShopping',
    module: 'TempExampleShoppingSix',
  },
  7: {
    group: 'SamsungShopping',
    module: 'TempExampleShoppingSeven',
  },
  8: {
    group: 'SamsungShopping',
    module: 'TempExampleShoppingEight',
  },
  9: {
    group: 'SamsungShopping',
    module: 'TempExampleShoppingNine',
  },
  10: {
    group: 'SamsungShopping',
    module: 'TempExampleShoppingTen',
  },
};

const tvGameBreak = {
  1: {
    group: 'SamsungGame',
    module: 'TempExampleGameOne',
  },
};

const tvDeliveryBreak = {
  1: {
    group: 'DoorDash',
    module: 'TempExampleDeliveryOne',
  },
};

const tvDeepLink = {
  1: {
    group: 'SamsungTvPlus',
    module: 'SimpleWatchNow',
  },
};

const tvOverlayStream = {
  1: {
    group: 'TransparentOverlays',
    module: 'TempOneLowerDeal',
  },
  2: {
    group: 'TransparentOverlays',
    module: 'TempOneLowerRightExpandableDeal',
  },
  3: {
    group: 'TransparentOverlays',
    module: 'TempThreeLowerCycleDeal',
  },
  6: {
    group: 'SimplePolls',
    module: 'TempEmojiPoll',
  },
  8: {
    group: 'SimplePolls',
    module: 'TempTriviaPoll',
  },
  9: {
    group: 'SimplePolls',
    module: 'TempPollStreamOverlay',
  },
  // // 10 avoids colliding with the backend's global TemplateModuleNumberEnum,
  // // where 4 is already taken by RIGHTTHIRDSCAN.
  10: {
    group: 'TransparentOverlays',
    module: 'TempProductHotspots',
  },
  11: {
    group: 'MultiStageOverlays',
    module: 'TempPickSellerAndOfferings',
  },
};

const templateTrees = {
  tvOverlayBreak,
  tvGameBreak,
  tvDeliveryBreak,
  tvDeepLink,
  tvOverlayStream,
};

export default templateTrees;
